<template>
<div class="chapter">
<div class="inner_page">
<p class="center">For my good and beautiful community:</p>
<p class="firstcenter">Meghan Smith, Matt Johnson, Catherine Johnson, Janeen Sehl, Patrick Sehl, Laura Fox, C. J. Fox, Jimm Taylor and Andrew Tash</p>
<p class="first"> </p>
<p class="first"> </p>
<p class="first"> </p>
<p class="firstcenter"><em>For standing with me,</em></p>
<p class="firstcenter"><em>heart and soul</em></p>
<p class="firstcenter">1 Samuel 14:7 niv</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?09a2aed2